module.exports = __webpack_public_path__ + "static/media/sf_hotel_16.74fbb573.jpg";